import actions from "./actions";
import deleteactions from "./deleteactions";
import send from "./send";

export default (
  state = {
    isFetchingResTypes: false,
    restypes: [],
    restypesListError: "",

    isFetchingRoomTypes: false,
    roomtypes: [],
    roomtypesListError: "",

    isFetchingResType: false,
    restypeCard: null,
    restypeCardError: "",

    isFetchingRoomType: false,
    roomtypeCard: null,
    roomtypeCardError: "",

    isDeletingResTypes: false,
    deletedResTypes: null,
    deletingResTypesError: "",

    isDeletingRoomTypes: false,
    deletedRoomTypes: null,
    deletingRoomTypesError: "",

    isUpdatingResType: false,
    updatedResType: null,
    restypeUpdateError: "",

    isUpdatingRoomType: false,
    updatedRoomType: null,
    roomtypeUpdateError: "",

    isCreatingResType: false,
    createdResType: null,
    restypeCreationError: "",

    isCreatingRoomType: false,
    createdRoomType: null,
    roomtypeCreationError: "",
  },
  action
) => {
  switch (action.type) {
    case actions.GET_RESOURCE_TYPES_REQUEST:
      return {
        ...state,
        isFetchingResTypes: action.isFetchingResTypes
      };
    case actions.GET_RESOURCE_TYPES_COMPLETED:
      return {
        ...state,
        isFetchingResTypes: action.isFetchingResTypes,
        restypes: action.restypes
      };
    case actions.GET_RESOURCE_TYPES_ERROR:
      return {
        ...state,
        isFetchingResTypes: action.isFetchingResTypes,
        restypesListError: action.restypesListError
      };

    case actions.GET_ROOM_TYPES_REQUEST:
      return {
        ...state,
        isFetchingRoomTypes: action.isFetchingRoomTypes
      };
    case actions.GET_ROOM_TYPES_COMPLETED:
      return {
        ...state,
        isFetchingRoomTypes: action.isFetchingRoomTypes,
        roomtypes: action.roomtypes
      };
    case actions.GET_ROOM_TYPES_ERROR:
      return {
        ...state,
        isFetchingRoomTypes: action.isFetchingRoomTypes,
        roomtypesListError: action.roomtypesListError
      };

    case actions.GET_RESOURCE_TYPE_REQUEST:
      return {
        ...state,
        isFetchingResType: action.isFetchingResType
      };
    case actions.GET_RESOURCE_TYPE_COMPLETED:
      return {
        ...state,
        isFetchingResType: action.isFetchingResType,
        restypeCard: action.restypeCard
      };
    case actions.GET_RESOURCE_TYPE_ERROR:
      return {
        ...state,
        isFetchingResType: action.isFetchingResType,
        restypeCardError: action.restypeCardError
      };

    case actions.GET_ROOM_TYPE_REQUEST:
      return {
        ...state,
        isFetchingRoomType: action.isFetchingRoomType
      };
    case actions.GET_ROOM_TYPE_COMPLETED:
      return {
        ...state,
        isFetchingRoomType: action.isFetchingRoomType,
        roomtypeCard: action.roomtypeCard
      };
    case actions.GET_ROOM_TYPE_ERROR:
      return {
        ...state,
        isFetchingRoomType: action.isFetchingRoomType,
        roomtypeCardError: action.roomtypeCardError
      };

    case deleteactions.DELETE_RESOURCE_TYPES_REQUEST:
      return {
        ...state,
        isDeletingResTypes: action.isDeletingResTypes
      };
    case deleteactions.DELETE_RESOURCE_TYPES_COMPLETED:
      return {
        ...state,
        isDeletingResTypes: action.isDeletingResTypes,
        deletedResTypes: action.deletedResTypes
      };
    case deleteactions.DELETE_RESOURCE_TYPES_ERROR:
      return {
        ...state,
        isDeletingResTypes: action.isDeletingResTypes,
        deletingResTypesError: action.deletingResTypesError
      };

    case deleteactions.DELETE_ROOM_TYPES_REQUEST:
      return {
        ...state,
        isDeletingRoomTypes: action.isDeletingRoomTypes
      };
    case deleteactions.DELETE_ROOM_TYPES_COMPLETED:
      return {
        ...state,
        isDeletingRoomTypes: action.isDeletingRoomTypes,
        deletedRoomTypes: action.deletedRoomTypes
      };
    case deleteactions.DELETE_ROOM_TYPES_ERROR:
      return {
        ...state,
        isDeletingRoomTypes: action.isDeletingRoomTypes,
        deletingRoomTypesError: action.deletingRoomTypesError
      };

    case send.UPDATE_RESOURCE_TYPE_REQUEST:
      return {
        ...state,
        isUpdatingResType: action.isUpdatingResType
      };
    case send.UPDATE_RESOURCE_TYPE_COMPLETED:
      return {
        ...state,
        isUpdatingResType: action.isUpdatingResType,
        updatedResType: action.updatedResType
      };
    case send.UPDATE_RESOURCE_TYPE_ERROR:
      return {
        ...state,
        isUpdatingResType: action.isUpdatingResType,
        restypeUpdateError: action.restypeUpdateError
      };

    case send.UPDATE_ROOM_TYPE_REQUEST:
      return {
        ...state,
        isUpdatingRoomType: action.isUpdatingRoomType
      };
    case send.UPDATE_ROOM_TYPE_COMPLETED:
      return {
        ...state,
        isUpdatingRoomType: action.isUpdatingRoomType,
        updatedRoomType: action.updatedRoomType
      };
    case send.UPDATE_ROOM_TYPE_ERROR:
      return {
        ...state,
        isUpdatingRoomType: action.isUpdatingRoomType,
        roomtypeUpdateError: action.roomtypeUpdateError
      };

    case send.CREATE_RESOURCE_TYPE_REQUEST:
      return {
        ...state,
        isCreatingResType: action.isCreatingResType
      };
    case send.CREATE_RESOURCE_TYPE_COMPLETED:
      return {
        ...state,
        isCreatingResType: action.isCreatingResType,
        createdResType: action.createdResType
      };
    case send.CREATE_RESOURCE_TYPE_ERROR:
      return {
        ...state,
        isCreatingResType: action.isCreatingResType,
        restypeCreationError: action.restypeCreationError
      };

    case send.CREATE_ROOM_TYPE_REQUEST:
      return {
        ...state,
        isCreatingRoomType: action.isCreatingRoomType
      };
    case send.CREATE_ROOM_TYPE_COMPLETED:
      return {
        ...state,
        isCreatingRoomType: action.isCreatingRoomType,
        createdRoomType: action.createdRoomType
      };
    case send.CREATE_ROOM_TYPE_ERROR:
      return {
        ...state,
        isCreatingRoomType: action.isCreatingRoomType,
        roomtypeCreationError: action.roomtypeCreationError
      };
    default:
      return state;
  }
};
